import { useEffect, useMemo, useReducer, useCallback, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  fetchCarouselRequest,
  fetchSingleCarouselRequest,
  toggleCarouselStatusRequest,
  resetToggleStatusFlags,
  deleteCarouselRequest,
  deleteCarouselLocationRequest,
} from '../../../../redux/slices/CarouselSlice'
import CreateSlide from './CreateSlide'
import { validate } from '../../../../assets/validation'
import SlideImagePreview from '../SlideImagePreview'
import ConfirmationDialog from '../../../Modals/ConfirmationModal'
import SlideItem from '../SlideItem'
import { toast } from "react-toastify";

import {
  Grid,
  Box,
  Card,
  Typography,
  CardContent,
  Button,
  Divider,
  Chip,
  Stack,
} from '@mui/material'


import axios from 'axios'
import EditCarousel from './EditCarousel'
import CarouselList from '../CarouselList'
import { canShowPermission } from '../../Permissions/permissionObject'
import { carouselGradientBtn, carouselOutlinedCard } from '../carouselStyles'

const initialFormData = {
  type: '',
  description: '',
  background_colors: [],
  background_directions: '',
  foreground_structure: '',
  actiontrigger: '',
  orientation: '',
  actiontrigger: '',
  foreground_texts: [{ text: '', color: '#b76262', style: 'normal', size: 12 }],
  background_image: '',
  foreground_images: [],
  createdAt: Date.now(),
  updatedAt: Date.now(),
  enabled: false
}

const initialState = {
  position: '',
  activeStep: null,
  showDialog: false,
  selectedStructure: '',
  addressType: 'home',
  id: null,
  openCreateSlide: false
}

function reducer(state, action) {
  switch (action.type) {
    case 'SET':
      return { ...state, ...action.payload }
    case 'RESET':
      return initialState
    default:
      return state
  }
}

const CarouselManager = ({ selectedScreen = '' }) => {
  const [loading, setLoading] = useState(false);
  const [controlState, dispatchControl] = useReducer(reducer, initialState);
  const [formData, setFormData] = useState(initialFormData);
  const [fieldErrors, setFieldErrors] = useState({});
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [editFormValues, setEditFormValues] = useState({
    carouselPosition: 'home_top',
    carouselHeight: '300',
    carouselDuration: '4',
  });
  const [selectedSlide, setSelectedSlide] = useState(null);
  const [loadingSlideId, setLoadingSlideId] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);

  const dispatch = useDispatch();
  const {
    data: carouselState,
    singleCarousel,
    toggleStatusSuccess,
    toggleStatusFailure,
    deleteSuccess,
  } = useSelector((state) => state.carousel)
  const [itemToDelete, setItemToDelete] = useState(null);
  const [locationToDelete, setLocationToDelete] = useState(null);
  const [locationDeleteDialogOpen, setLocationDeleteDialogOpen] = useState(false);

  const carouselList = useMemo(() => carouselState?.carousellist || [], [carouselState])

  useEffect(() => {
    if (selectedScreen && selectedScreen !== controlState.position) {
      dispatchControl({
        type: 'SET',
        payload: { position: selectedScreen, activeStep: null, id: null },
      });
    }
  }, [selectedScreen, controlState.position]);

  useEffect(() => {
    dispatch(fetchCarouselRequest());
  }, [dispatch]);

  const [permissions, setPermissions] = useState({});
  useEffect(() => {
    const storedPermissions = localStorage.getItem("userPermissions");
    if (storedPermissions) {
      try {
        setPermissions(JSON.parse(storedPermissions));
      } catch (error) {
        console.error("Error parsing stored permissions", error);
      }
    }
  }, []);
  const canCreate = canShowPermission(permissions, "carouselsettings", "create");
  const canEdit = canShowPermission(permissions, "carouselsettings", "edit");
  const canDelete = canShowPermission(permissions, "carouselsettings", "delete");

  useEffect(() => {
    if (toggleStatusSuccess || toggleStatusFailure) {
      setLoadingSlideId(null)
      setTimeout(() => {
        dispatch(resetToggleStatusFlags())
      }, 500)
    }
  }, [toggleStatusSuccess, toggleStatusFailure, dispatch])

  useEffect(() => {
    if (deleteSuccess && controlState.id) {
      setFormData(initialFormData)
      dispatch(fetchSingleCarouselRequest(controlState.id));
    }
  }, [deleteSuccess, controlState.id, dispatch]);


  const handleLoadSingleCarousel = useCallback((id) => {
    setFormData((prev) => ({ ...prev, carousel: id }))
    dispatch(fetchSingleCarouselRequest(id))
  }, [dispatch])

  const handleSelectItem = useCallback((index, item) => {
    const isActive = controlState.activeStep === index
    const newActiveStep = isActive ? null : index
    const newId = isActive ? null : item._id

    dispatchControl({
      type: 'SET',
      payload: {
        activeStep: newActiveStep,
        id: newId
      }
    })

    if (newId) handleLoadSingleCarousel(newId)
  }, [controlState.activeStep, handleLoadSingleCarousel])

  const handleSubmitSlide = async (form) => {
      setLoading(true);

  // fallback reset after 2s
  const timeout = setTimeout(() => setLoading(false), 2000);
    try {
      const finalPayload = {
        ...form,
        foreground_structure: controlState.selectedStructure,
        carousel: controlState.id || formData.carousel || '',
        createdAt: Date.now(),
        updatedAt: Date.now()
      }

      const formDatas = new FormData()
    formDatas.append('carousel', finalPayload.carousel?.toString().trim() || '');
formDatas.append('type', finalPayload.type?.trim() || '');
formDatas.append('description', finalPayload.description?.trim() || '');
formDatas.append('background_directions', finalPayload.background_directions?.trim() || '');
formDatas.append('foreground_structure', finalPayload.foreground_structure?.trim() || '');
formDatas.append('orientation', finalPayload.orientation?.trim() || '');
formDatas.append('actiontrigger', finalPayload.actiontrigger?.trim() || '');
formDatas.append('createdAt', finalPayload.createdAt?.toString().trim() || '');
formDatas.append('updatedAt', finalPayload.updatedAt?.toString().trim() || '');
formDatas.append('enabled', finalPayload.enabled?.toString().trim() || '');
      if (finalPayload._id) {
        formDatas.append('_id', finalPayload._id)
      }

      formDatas.append('background_colors', JSON.stringify(finalPayload.background_colors))
      formDatas.append('foreground_texts', JSON.stringify(finalPayload.foreground_texts))

      if (finalPayload.background_image instanceof File) {
        formDatas.append('background_image', finalPayload.background_image)
      } else if (typeof finalPayload.background_image === 'string') {
        formDatas.append('background_image', finalPayload.background_image)
      }

      finalPayload.foreground_images.forEach((file) => {
        if (file instanceof File) {
          formDatas.append('file', file)
        }
      })

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/carousel/saveslidedetails`,
        formDatas,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      )

      if (response?.data?.success) {
        console.log('Slide saved successfully:', response.data)
        toast.success("Slide Details Saved Successfully");
        setFormData(initialFormData);
        dispatchControl({ type: 'SET', payload: { openCreateSlide: false, showDialog: false } })
        setLoading(false);

      }

    } catch (error) {
      console.log('Error saving slide:', error)
    }
    finally {
    clearTimeout(timeout);
    setLoading(false);
  }
  }

  const handleEditChange = (e) => {
    const { name, value } = e.target
    setEditFormValues((prev) => ({ ...prev, [name]: value }))
  }

  const handleEditSubmit = () => {
    console.log('Edit form submitted:', editFormValues)
    setEditDialogOpen(false)
  }

  const handleEditClose = () => setEditDialogOpen(false)

  const handleEdit = (item) => {
    setFormData({
      ...item,
      foreground_texts: item.foreground_texts?.length
        ? item.foreground_texts
        : [{ text: '', color: '#b76262', style: 'normal', size: 12 }],
      foreground_images: [],
      background_colors: item.background_colors || [],
      enabled: item.enabled ?? false,
      updatedAt: Date.now(),
    })

    dispatchControl({
      type: 'SET',
      payload: {
        selectedStructure: item.foreground_structure || '',
        showDialog: true,
        openCreateSlide: true,
      },
    })
  }

  const handleView = (item) => setSelectedSlide(item);

  const handleDelete = () => {
    if (!itemToDelete || !itemToDelete._id) {
      toast.error("Slide ID is missing. Cannot delete.");
      console.error("Missing itemToDelete or _id:", itemToDelete);
      return;
    }

    dispatch(deleteCarouselRequest(itemToDelete._id));
    setDialogOpen(false);
    // setItemToDelete(null);
  };


  const handleToggleStatus = async (item) => {
      setLoadingSlideId(item._id); // loader for this slide

    dispatch(toggleCarouselStatusRequest({
      slideId: item._id,
      enabled: !item.enabled,
      carouselId: controlState.id,
    }));
     // optional timeout fallback (in case API doesn't reset properly)
  setTimeout(() => {
    setLoadingSlideId(null);
  }, 2000); // reset after 5 sec
  }

  const handleCloseDialog = () => setSelectedSlide(null)

  const handleConfirmDeleteLocation = () => {
    if (!locationToDelete?._id) {
      toast.error('Location ID is missing. Cannot delete.');
      return;
    }
    dispatch(deleteCarouselLocationRequest(locationToDelete._id));
    setLocationDeleteDialogOpen(false);
    setLocationToDelete(null);
    if (controlState.id === locationToDelete._id) {
      dispatchControl({
        type: 'SET',
        payload: { activeStep: null, id: null },
      });
    }
  };

  const filteredCarouselList = useMemo(() => {
    const search = (selectedScreen || controlState?.position || '').trim();
    if (!search) return carouselList;
    return carouselList.filter((carousel) => carousel?.location?.startsWith(search));
  }, [carouselList, selectedScreen, controlState?.position]);

  const selectedLocation = filteredCarouselList[controlState.activeStep];

  return (
    <>
    <Card variant="outlined" sx={{ width: '100%', ...carouselOutlinedCard }}>
      <Box
        sx={{
          p: 2,
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: { xs: 'stretch', sm: 'center' },
          justifyContent: 'space-between',
          gap: 2,
        }}
      >
        <Stack direction="row" alignItems="center" spacing={1} flexWrap="wrap">
          {selectedScreen && (
            <Chip
              label={`Screen: ${selectedScreen}`}
              size="small"
              sx={{ bgcolor: '#f2eaff', color: '#7A3FFF', fontWeight: 600 }}
            />
          )}
          {selectedLocation && (
            <Chip
              label={selectedLocation.label || selectedLocation.location}
              size="small"
              variant="outlined"
              color="secondary"
            />
          )}
          <Chip
            label={`${filteredCarouselList.length} location${filteredCarouselList.length !== 1 ? 's' : ''}`}
            size="small"
          />
        </Stack>
        {controlState?.id && canCreate && (
          <Button
            variant="contained"
            fullWidth
            onClick={() => dispatchControl({ type: 'SET', payload: { showDialog: true } })}
            sx={{ ...carouselGradientBtn, width: { xs: '100%', sm: 'auto' } }}
          >
            Add Slide
          </Button>
        )}
      </Box>

      <Divider />

      <CardContent sx={{ p: { xs: 1.5, sm: 2 } }}>
        <Grid container spacing={2}>
          <Grid item xs={12} lg={4}>
            <Typography
              variant="subtitle2"
              color="text.secondary"
              sx={{ mb: 1, fontWeight: 600 }}
            >
              Locations
            </Typography>
            <Box
              sx={{
                maxHeight: { xs: 280, sm: 360, lg: 480 },
                overflowY: 'auto',
                overflowX: 'hidden',
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 2,
                p: 1,
                bgcolor: '#fafafa',
                WebkitOverflowScrolling: 'touch',
                overscrollBehavior: 'contain',
              }}
            >
              <CarouselList
                carouselList={filteredCarouselList}
                activeStep={controlState.activeStep}
                onSelect={handleSelectItem}
                canDelete={canDelete}
                onDeleteLocation={(item) => {
                  setLocationToDelete(item);
                  setLocationDeleteDialogOpen(true);
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={12} lg={8}>
            <Typography
              variant="subtitle2"
              color="text.secondary"
              sx={{ mb: 1, fontWeight: 600 }}
            >
              Slides
            </Typography>
            <Box
              sx={{
                maxHeight: { xs: 360, sm: 400, lg: 480 },
                overflowY: 'auto',
                width: '100%',
              }}
            >
              {controlState.activeStep !== null && singleCarousel ? (
                <Stack spacing={1.5}>
                  {singleCarousel.map((item) => (
                    <SlideItem
                      key={item._id}
                      item={item}
                      loadingSlideId={loadingSlideId}
                      onToggle={handleToggleStatus}
                      onView={handleView}
                      onEdit={handleEdit}
                      onDelete={() => {
                        setItemToDelete(item);
                        setDialogOpen(true);
                      }}
                      canEdit={canEdit}
                      canDelete={canDelete}
                    />
                  ))}
                </Stack>
              ) : (
                <Box
                  sx={{
                    border: '1px dashed #e0d8f5',
                    borderRadius: 2,
                    p: 4,
                    textAlign: 'center',
                    bgcolor: '#faf8ff',
                  }}
                >
                  <Typography variant="body1" color="text.secondary">
                    {!selectedScreen
                      ? 'Select a screen above to view locations'
                      : filteredCarouselList.length === 0
                      ? `No locations for "${selectedScreen}"`
                      : 'Select a location from the list to manage slides'}
                  </Typography>
                </Box>
              )}
            </Box>
          </Grid>
        </Grid>
      </CardContent>

      <EditCarousel
        open={editDialogOpen}
        onClose={handleEditClose}
        formValues={editFormValues}
        onChange={handleEditChange}
        onSubmit={handleEditSubmit}
      />
      <CreateSlide
        show={controlState.showDialog}
        setShow={(val) => dispatchControl({ type: 'SET', payload: { showDialog: val } })}
        selectedStructure={controlState.selectedStructure}
        setSelectedStructure={(val) => dispatchControl({ type: 'SET', payload: { selectedStructure: val } })}
        addressType={controlState.addressType}
        setAddressType={(val) => dispatchControl({ type: 'SET', payload: { addressType: val } })}
        onClose={() => {
          // setFormData(initialFormData)
          dispatchControl({ type: 'SET', payload: { openCreateSlide: false } })
        }}
        onSubmit={handleSubmitSlide}
        open={controlState.openCreateSlide}
        carouselstructure={carouselState?.carouselstructure || []}
        corousel_type={carouselState?.corousel_type || []}
        carouselorientation={carouselState?.carouselorientation || []}
        carouseldirection={carouselState?.carouseldirection || []}
        slidestyles={carouselState?.slidestyles || []}
        formData={formData}
        setFormData={setFormData}
        fieldErrors={fieldErrors}
        setFieldErrors={setFieldErrors}
        loading={loading}
        setLoading={setLoading}
      />

      <SlideImagePreview open={!!selectedSlide} onClose={handleCloseDialog} slide={selectedSlide} />
      <ConfirmationDialog
        open={dialogOpen}
        onClose={() => {
          setDialogOpen(false);
          setItemToDelete(null);
        }}
        onConfirm={handleDelete}
        title="Are you sure?"
        content="Would you like to remove this item from the list?"
      />
      <ConfirmationDialog
        open={locationDeleteDialogOpen}
        onClose={() => {
          setLocationDeleteDialogOpen(false);
          setLocationToDelete(null);
        }}
        onConfirm={handleConfirmDeleteLocation}
        title="Delete location?"
        content={`Delete custom location "${locationToDelete?.label || locationToDelete?.location || ''}" and its slides? This cannot be undone.`}
      />
         </Card>
    </>
  )
}

export default CarouselManager;

